import { Button } from "@mui/material";
import { useEffect } from "react";
import ProjectList from "../ProjectList";
import About from "./about";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default function Home() {
  useEffect(() => {
    document.title = "Home - CGO";
  }, []);

  async function enableNotifications() {
    let registration;
    console.log(navigator);
    if (navigator.serviceWorker) {
      registration = await navigator.serviceWorker.register("./notificationWorker.js", { scope: "/" });
      console.log("Registered service worker");
    }

    console.log("Registering push");
    const publicVapidKey = "BAJ_TUxJWMoYtt34_Kc5ouQ9FWX3i6VnCSy8uuyqnynFSeg340VpUAS-ZM-U9YA_Q65wFg-X32y1LrmMg27WO7w";
    const subscription = await registration?.pushManager.subscribe({
      userVisibleOnly: true,
      // The `urlBase64ToUint8Array()` function is the same as in
      // https://www.npmjs.com/package/web-push#using-vapid-key-for-applicationserverkey
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
    });
    console.log("Registered push", subscription);

    console.log("Sending push");
    await fetch("/api/subscribe", {
      method: "POST",
      body: JSON.stringify(subscription),
      headers: {
        "content-type": "application/json",
      },
    });
  }

  let pageContent = <></>;
  if (localStorage.getItem("about-red")) {
    pageContent = (
      <>
        <div>
          Push notifications are handy: they let you know a table you have joined has started, or when a new player has
          joined your table. Also, they let you know it is your turn when you don't have the table open. You need to
          explicitly allow them:
          <Button variant="contained" onClick={enableNotifications}>
            Turn on notifications
          </Button>
        </div>
        <ProjectList />
      </>
    );
  } else {
    pageContent = (
      <>
        <div>
          You are in! We are glad to have you here! <br />
          Before playing, please, take a moment to skim through the following paragraphs:
        </div>
        <About />
        <div>Note: you can return to this document by going to the "How to use" page from the navigation menu</div>
        <div style={{ padding: "25px" }}>
          <Button
            variant="contained"
            onClick={(evt) => {
              localStorage.setItem("about-red", "true");
              location.reload();
            }}
          >
            Got it, let me in already!
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="home">
      <h1>Welcome to CGO</h1>
      {pageContent}
    </div>
  );
}
